import { render, staticRenderFns } from "./pay_order_page.vue?vue&type=template&id=4ecbdc90&scoped=true"
import script from "./pay_order_page.vue?vue&type=script&lang=js"
export * from "./pay_order_page.vue?vue&type=script&lang=js"
import style0 from "./pay_order_page.vue?vue&type=style&index=0&id=4ecbdc90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecbdc90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecbdc90')) {
      api.createRecord('4ecbdc90', component.options)
    } else {
      api.reload('4ecbdc90', component.options)
    }
    module.hot.accept("./pay_order_page.vue?vue&type=template&id=4ecbdc90&scoped=true", function () {
      api.rerender('4ecbdc90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/pay_order_page.vue"
export default component.exports